import React from 'react';
import '../css/Hero.css';
import perfumeImage from '../assets/images/gitaami.png'; // replace with actual path

const Hero = () => {
  return (
    <section className="gitaami-hero">
      <div className="gitaami-left">
        <h1 className="gitaami-name">Gitaami</h1>
        <br />
        <p className="gitaami-subheading">Let's Redefine Wellness — Together
Explore a new kind of care. The kind that honors where you come from and empowers where you're going.
Welcome to Gitaami. This is your story too.</p>
        
        <p className='g-sub'>Welcome to Gitaami. This is your story too.</p>
      </div>

      <div className="gitaami-image">
        <img src={perfumeImage} alt="Perfume Bottle" />
      </div>
    </section>
  );
};

export default Hero;
